/**
 * LUXCHAM — AI JEWELLERY CONCIERGE
 * luxcham-ai-concierge.js
 */

(function() {
  'use strict';

  // State
  const state = {
    occasion: null,
    category: null,
    metal: null,
    diamond: null,
    budget: null,
    currentStep: 1,
    products: []
  };

  // DOM Elements
  let trigger, modal, closeBtn, backdrop;

  function init() {
    const triggers = document.querySelectorAll('#LxcAiTrigger, #LxcAiTriggerHeader, .lxc-ai-trigger-header, [data-open-ai-stylist]');
    modal = document.querySelector('#LxcAiModal');
    closeBtn = document.querySelector('#LxcAiClose');
    backdrop = document.querySelector('#LxcAiBackdrop');

    if (!modal) return;

    if (triggers && triggers.length) {
      triggers.forEach(t => t.addEventListener('click', openModal));
    }
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);

    bindOptionClicks();
    fetchProductCatalog();
  }

  function resetConcierge() {
    state.occasion = null;
    state.category = null;
    state.metal = null;
    state.diamond = null;
    state.budget = null;
    state.currentStep = 1;

    // Deselect all options
    document.querySelectorAll('.lxc-ai-option').forEach(opt => {
      opt.classList.remove('is-selected');
    });

    // Reset back to Step 1 view & progress bar
    goToStep(1);

    // Clear recommendations container if populated
    const recsContainer = document.querySelector('#LxcAiRecsContainer');
    if (recsContainer) recsContainer.innerHTML = '';
  }

  function openModal() {
    resetConcierge();
    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lxc-modal-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lxc-modal-open');
    document.body.style.overflow = '';
    setTimeout(resetConcierge, 350);
  }

  function bindOptionClicks() {
    const options = document.querySelectorAll('.lxc-ai-option');
    options.forEach(opt => {
      opt.addEventListener('click', () => {
        const stepNum = parseInt(opt.dataset.step, 10);
        const val = opt.dataset.val;

        // Toggle selected state within this step
        const parentStep = opt.closest('.lxc-ai-step');
        parentStep.querySelectorAll('.lxc-ai-option').forEach(o => o.classList.remove('is-selected'));
        opt.classList.add('is-selected');

        // Record choice
        if (stepNum === 1) state.occasion = val;
        if (stepNum === 2) state.category = val;
        if (stepNum === 3) state.metal = val;
        if (stepNum === 4) state.diamond = val;
        if (stepNum === 5) state.budget = val;

        // Auto advance to next step after brief micro-delay
        setTimeout(() => {
          if (stepNum < 5) {
            goToStep(stepNum + 1);
          } else {
            generateRecommendations();
          }
        }, 180);
      });
    });
  }

  function goToStep(num) {
    state.currentStep = num;

    // Update steps view
    document.querySelectorAll('.lxc-ai-step').forEach((s, idx) => {
      if (idx + 1 === num) {
        s.classList.add('is-active');
      } else {
        s.classList.remove('is-active');
      }
    });

    // Update progress bars
    document.querySelectorAll('.lxc-ai-progress__step').forEach((p, idx) => {
      if (idx + 1 <= num) {
        p.classList.add('is-active');
      } else {
        p.classList.remove('is-active');
      }
    });
  }

  async function fetchProductCatalog() {
    try {
      const res = await fetch('/products.json?limit=50');
      if (res.ok) {
        const data = await res.json();
        state.products = data.products || [];
      }
    } catch (e) {
      console.warn('[Luxcham AI] Catalog fetch fallback active');
    }
  }

  function generateRecommendations() {
    goToStep(6); // Results step

    const recsContainer = document.querySelector('#LxcAiRecsContainer');
    if (!recsContainer) return;

    recsContainer.innerHTML = '<div style="text-align:center;padding:30px;color:#C9A84C;"><span class="lxc-ai-trigger__spark">✦</span> Analyzing natural diamond inventory...</div>';

    setTimeout(() => {
      let filtered = state.products;

      // Category filter
      if (state.category && state.category !== 'all') {
        filtered = filtered.filter(p => (p.product_type || '').toLowerCase().includes(state.category) || (p.tags || []).some(t => t.toLowerCase().includes(state.category)));
      }

      // If not enough products, fallback to top catalog pieces
      if (filtered.length < 3) {
        filtered = state.products.slice(0, 6);
      }

      // Pick top 3 to 6
      const results = filtered.slice(0, 6);

      recsContainer.innerHTML = '';

      results.forEach(p => {
        const img = p.images && p.images[0] ? p.images[0].src : '';
        const whyReason = getWhyReason(p, state);

        const card = document.createElement('div');
        card.className = 'lxc-ai-rec-card';
        card.innerHTML = `
          <img class="lxc-ai-rec-card__img" src="${img}" alt="${p.title}" loading="lazy">
          <div class="lxc-ai-rec-card__body">
            <h3 class="lxc-ai-rec-card__title">${p.title}</h3>
            <div class="lxc-ai-rec-card__why">
              <strong>Why this piece?</strong> ${whyReason}
            </div>
            <div class="lxc-passport-badge">✦ IGI/GIA Certified</div>
            <div class="lxc-ai-rec-card__actions" style="margin-top:8px;">
              <a href="/products/${p.handle}" class="lxc-ai-btn lxc-ai-btn--gold lxc-ai-action-buy">View & Buy</a>
              <a href="https://wa.me/919925861016?text=${encodeURIComponent("Hi LUXCHAM, I'm interested in: " + p.title + " - https://luxchamjewellery.com/products/" + p.handle)}" target="_blank" class="lxc-ai-btn lxc-ai-btn--outline">Consult Expert</a>
            </div>
          </div>
        `;

        // Auto-close modal when user clicks View & Buy
        card.querySelector('.lxc-ai-action-buy').addEventListener('click', () => {
          closeModal();
        });

        recsContainer.appendChild(card);
      });

      // Add "Start Over" and "Close" action buttons at bottom of results
      const hideFooter = document.createElement('div');
      hideFooter.style.cssText = 'text-align:center;margin-top:16px;display:flex;gap:10px;justify-content:center;flex-wrap:wrap;';
      hideFooter.innerHTML = `
        <button type="button" class="lxc-ai-btn lxc-ai-btn--gold" style="width:auto;padding:8px 20px;display:inline-flex;align-items:center;gap:4px;" id="LxcAiRestartBtn">
          ✦ Start Over
        </button>
        <button type="button" class="lxc-ai-btn lxc-ai-btn--outline" style="width:auto;padding:8px 20px;display:inline-flex;align-items:center;gap:4px;" id="LxcAiHideBtn">
          ✕ Close
        </button>
      `;
      recsContainer.appendChild(hideFooter);

      document.querySelector('#LxcAiRestartBtn').addEventListener('click', resetConcierge);
      document.querySelector('#LxcAiHideBtn').addEventListener('click', closeModal);

    }, 400);
  }

  function getWhyReason(prod, st) {
    const reasons = [
      `Curated specifically for ${st.occasion || 'your special moment'}, matching your preference for ${st.diamond || 'natural solitaire diamonds'}.`,
      `Crafted in ${st.metal || '18K Gold'}, highlighting high color and clarity natural diamonds with perfect optical symmetry.`,
      `Ideal choice for ${st.category || 'fine jewellery'} lovers seeking timeless sophistication within your target investment range.`
    ];
    return reasons[Math.floor(Math.random() * reasons.length)];
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
